<template>
  <div>
    <v-main>
      <v-sheet max-width="800" class="mx-auto px-12 py-6 my-6" rounded outlined>
        <div v-if="loading">
          <v-skeleton-loader
            type="text"
            width="200"
            class="my-6"
          ></v-skeleton-loader>
        </div>
        <div v-else class="mb-6 text-h4">
          <Ressource code="titre-formulaire" />
        </div>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <ophq-loading v-else-if="envoiEnCours">
          <div class="mt-5">Traitement de la demande en cours...</div>
        </ophq-loading>
        <v-alert type="success" text v-else-if="envoiReussi">
          <Ressource code="formulaire-soumis" />
        </v-alert>
        <v-alert type="error" text v-else-if="echecEnvoi">
          <Ressource code="formulaire-erreur" />
          <ul v-if="erreurs.length > 0">
            <li v-for="erreur in erreurs" :key="erreur">{{ erreur }}</li>
          </ul>
        </v-alert>
        <div v-else>
          <v-form v-model="valid" ref="formulaire" :disabled="envoiEnCours">
            <h5 class="text-h5 mb-6">
              <Ressource code="titre-etape-2" />
            </h5>
            <v-row>
              <v-col cols="6">
                <SearchOrganisation
                  @organisation-selected="organisationSelected($event)"
                ></SearchOrganisation>
              </v-col>
              <v-col cols="6">
                <OrganisationCardContent :organisation="lieuExercice" />
              </v-col>
            </v-row>
            <v-alert
              type="warning"
              text
              icon="mdi-alert-circle-outline"
              class="pl-8 mb-8"
              max-width="600"
              v-if="afficherRetourALaPratique"
            >
              <ressource code="avertissement_retour_pratique" />
            </v-alert>

            <!-- TODO implémenter la gestion par UID dans le framework pour les cas ou le code n'est pas disponible -->
            <TextField
              code="pro_fonction"
              v-model="lieuExercice.fonction"
              v-if="
                lieuExercice.secteurActivite ==
                $constants.FILEDATA_ID.SAS_ADRESSE.SECTEUR_ACTIVITE
                  .AUTRE_SECTEUR
              "
            />
            <DatePicker
              code="pro_date_debut"
              v-model="lieuExercice.dateDeDebut"
              :minValue="dateDebutMinimal"
              :maxValue="infos.serverDateTime"
            />
            <CaseACocher
              code="pro_principal"
              v-model="lieuExercice.lieuExercicePrincipal"
            />
            <CaseACocher
              code="pro_correspondance"
              v-model="lieuExercice.lieuCorrespondancePostale"
            />
            <v-divider />
            <h5 class="text-h5 my-6">
              <Ressource
                code="titre-etape-3"
                v-if="categorieAssuranceActiveBOuPasDAssurance"
              />
            </h5>

            <template v-if="categorieAssuranceActiveBOuPasDAssurance">
              <Catalogue code="assu_critere1" v-model="assurance.critere1" />
              <Catalogue code="assu_critere2" v-model="assurance.critere2" />
              <Catalogue code="assu_critere3" v-model="assurance.critere3" />
              <Catalogue code="assu_critere4" v-model="assurance.critere4" />
              <Catalogue code="assu_critere5" v-model="assurance.critere5" />
              <Catalogue code="assu_critere6" v-model="assurance.critere6" />
            </template>
            <Catalogue
              code="assu_categorie_auto"
              ref="categorieCalculee"
              v-model="assurance.categorieDAssuranceCalculee"
              disabled
              v-if="categorieAssuranceActiveBOuPasDAssurance"
            />
            <Ressource
              code="tableau_assurances"
              v-if="
                categorieCalculee === 'B' &&
                categorieAssuranceActiveBOuPasDAssurance
              "
            />
            <CatalogueLive
              code="assu_categorie_choix"
              :opqIf="categorieCalculee === 'B'"
              v-model="assurance.categorieDAssuranceSelectionnee"
              v-if="categorieAssuranceActiveBOuPasDAssurance"
            />
            <CaseACocherLive
              :opqIf="categorieChoisie === 'B'"
              code="assu_categorie_decla"
              v-model="assurance.declarationCategorieB"
              v-if="categorieAssuranceActiveBOuPasDAssurance"
            />

            <v-alert type="warning" text v-if="regularisationAssuranceRequise">
              <Ressource code="regularisation_assurance" />
            </v-alert>

            <v-btn
              @click="send"
              color="primary"
              x-large
              :disabled="envoiEnCours"
            >
              <Ressource code="titre-soumission" />
              <v-icon class="ml-3">mdi-send</v-icon>
            </v-btn>
          </v-form>
        </div>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import ParamFormulaireBase from "@/components/ui/mixins/ParamFormulaireBase"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CataloguesHelper from "@/components/ui/mixins/CataloguesHelpers"
import SearchOrganisation from "@/components/Common/SearchOrganisation.vue"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import Ressource from "@/components/ui/Ressource.vue"
import LieuExercice from "@/models/LieuExercice"
import Assurance from "@/models/Assurance"
import { Api } from "@/plugins/api"
import TokenContact from "@/mixins/TokenContact"

export default {
  mixins: [ParamFormulaireBase, CataloguesHelper, TokenContact, DatesHelpers],
  components: { SearchOrganisation, OrganisationCardContent, Ressource },
  data() {
    return {
      valid: false,
      envoiEnCours: false,
      envoiReussi: false,
      echecEnvoi: false,
      erreurs: [],
      lieuExercice: new LieuExercice(),
      assurance: new Assurance(),
      url: "demande-ajout-lieu-exercice",
      infos: {
        codeCategorieAssurance: null,
        afficherRetourALaPratique: false,
        serverDateTime: null,
      },
    }
  },
  metaInfo() {
    return {
      title: "OPQ - Ajout d'un lieu d'exercice",
    }
  },
  async mounted() {
    if (!this.$route.query.token) {
      this.$router.push({ name: "Unauthorized" })
    }
    await this.loadToken()
    await this.loadParams("ajout_lieu_exercice")

    this.loadContact()
    this.getInfos()
      .then((response) => {
        this.infos = response.data
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$router.push({ name: "Unauthorized" })
        } else {
          this.$router.push({
            name: "Internal",
            params: { message: err.response.data },
          })
        }
      })
  },
  computed: {
    categorieCalculee() {
      const ouiUnCritere =
        this.estOui(this.assurance.critere1) ||
        this.estOui(this.assurance.critere2) ||
        this.estOui(this.assurance.critere3) ||
        this.estOui(this.assurance.critere4) ||
        this.estOui(this.assurance.critere5) ||
        this.estOui(this.assurance.critere6)

      const unEmployeurCategorieA =
        !this.lieuExercice.inactif &&
        (this.lieuExercice.codeCategorieEtablissement === "A" ||
          this.lieuExercice.codeCategorieEtablissement === "Autre consultation")

      if (ouiUnCritere || unEmployeurCategorieA) {
        return "A"
      }

      return "B"
    },
    categorieChoisie() {
      return this.getCatalogueCodeById(
        "7903",
        this.assurance.categorieDAssuranceSelectionnee
      )
    },
    regularisationAssuranceRequise() {
      return (
        this.lieuExercice.codeCategorieEtablissement &&
        ((this.categorieCalculee == "A" &&
          this.infos.codeCategorieAssurance == "B") ||
          !this.infos.codeCategorieAssurance)
      )
    },
    afficherRetourALaPratique() {
      return (
        this.lieuExercice &&
        this.lieuExercice.pratiqueAupresDuPublic == true &&
        this.infos &&
        this.infos.afficherRetourALaPratique == true
      )
    },
    dateDebutMinimal() {
      const now = new Date(this.infos.serverDateTime)
      return this.convertDateToString(new Date(now.setDate(now.getDate() - 90)))
    },
    categorieAssuranceActiveBOuPasDAssurance() {
      return (
        this.infos.codeCategorieAssurance === "B" ||
        !this.infos.codeCategorieAssurance
      )
    },
  },
  watch: {
    categorieCalculee(newValue) {
      this.$refs.categorieCalculee.setValueByCode(newValue)
    },
  },
  methods: {
    reset() {
      this.lieuExercice = new LieuExercice()
      this.assurance = new Assurance()
    },

    resetFlags() {
      this.envoiEnCours = false
      this.envoiReussi = false
      this.echecEnvoi = false
      this.erreurs = []
    },

    async send() {
      this.resetFlags()
      if (this.$refs.formulaire.validate()) {
        this.envoiEnCours = true
        let formulaire = {
          lieuExercice: this.lieuExercice,
          assurance: this.assurance,
          tokenExtranet: this.tokenExtranet,
        }
        Api.post(this.url, formulaire)
          .then((res) => {
            if (res.data.hasValidationErrors) {
              this.erreurs = res.data.errors
              this.echecEnvoi = true
            } else {
              this.envoiReussi = true
              this.reset()
            }
          })
          .catch(() => {
            this.echecEnvoi = true
          })
          .finally(() => {
            this.envoiEnCours = false
          })
      }
    },
    organisationSelected(org) {
      this.lieuExercice = { ...org }
      if (
        this.categorieCalculee !==
        this.getCatalogueCodeById(
          "7903",
          this.assurance.categorieDAssuranceCalculee
        )
      ) {
        this.$refs.categorieCalculee.setValueByCode(this.categorieCalculee)
      }
    },
    getInfos() {
      const encodedToken = encodeURIComponent(this.tokenExtranet)

      return Api.get(this.url + "?token=" + encodedToken)
    },
  },
}
</script>
